import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import add from "../../images/add.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";

export function EditStock({ getData, setShow, editData }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({
    video: "",
  });
  const [isRecording, setIsRecording] = useState(false);
  const [selectedImg, setSelectedImg] = useState([]);
  const [selectedPDF, setSelectedPDF] = useState(null);

  const handleSubmit = async () => {
    try {
      setLoader(true);
      const formData = {
        _id: editData?._id,
        description: inputData?.description,
        video: inputData?.video || "",
        pdfFile: inputData?.pdfFile || "",
        imageTitle: inputData?.imageTitle || "",
        imageFormat: inputData?.imageFormat || "",
      };

      const signalResponse = await api.stocksEdit(formData);
      // console.log(signalResponse);

      if (signalResponse?.success) {
        alert("Stock edit successfully");
        setInputData({
          video: "",
        });

        setLoader(false);
        setShow(false);
        getData();
      } else {
        setLoader(false);
        alert("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  const handleChange = (e) => {
    // console.log(e);
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setInputData({
      description: editData?.description || "",
      video: editData?.video || "",
      pdfFile: editData?.pdfFile || "",
      imageTitle: editData?.imageTitle || "",
      imageFormat: editData?.imageFormat || "",
    });
  }, []);

  const onFileChange = async (e) => {
    try {
      setLoader(true);
      if (!e.target.files) {
        return;
      }
      const formData = new FormData();
      // formData.append("image", e.target.files[0], e.target.files[0].name);
      for (let file of e.target.files) {
        formData.append("image", file);
      }
      const uploadRes = await api.uploadFile(formData);
      // console.log(uploadRes);
      let sImage = [];
      var imgName = uploadRes[0].split(",");
      var imgFormat = uploadRes[1].split(",");
      for (let i = 0; i < imgName.length; i++) {
        sImage.push(
          `${process.env.REACT_APP_S3URL}/img_${imgName[i]}.${imgFormat[i]}`
        );
      }
      setSelectedImg(sImage);
      setInputData({
        ...inputData,
        imageTitle: uploadRes[0],
        imageFormat: uploadRes[1],
      });
      setLoader(false);
    } catch (e) {
      alert("File upload failed");
      setLoader(false);
      console.log(e.message);
    }
  };

  const onPDFChange = async (e) => {
    try {
      setLoader(true);

      const formData = new FormData();
      formData.append("pdf", e.target.files[0], e.target.files[0].name);
      const uploadRes = await api.uploadPDF(formData);
      // console.log(uploadRes);
      setSelectedPDF(`${process.env.REACT_APP_S3URL}/${uploadRes}`);
      setInputData({
        ...inputData,
        pdfFile: `${uploadRes}`,
      });
      setLoader(false);
    } catch (e) {
      alert("File upload failed");
      setLoader(false);
      console.log(e.message);
    }
  };

  return (
    <>
      <div className="row mx-0 drivers-row">
        <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
          <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
            Edit Stock Updates
          </h4>
        </div>
      </div>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="descMainPost">
            <div className="form-group mb-3">
              <ReactQuill
                placeholder="Add description"
                modules={Editor}
                theme="snow"
                value={inputData.description}
                onChange={(e) => setInputData({ ...inputData, description: e })}
              />
            </div>

            <div className="form-group mb-3">
              <textarea
                name="video"
                id=""
                className="form-control"
                onChange={handleChange}
                value={inputData?.video}
                placeholder="Add Video Iframe"
              ></textarea>
            </div>
          </div>
          <div className="form-group mb-3 fileUpload-modal">
            <label>
              <input
                name="file"
                onChange={onFileChange}
                accept="image/*"
                type={"file"}
                multiple
              />
              <img src={add} />
            </label>
          </div>

          <div className="uploadedImage">
            {selectedImg.length > 0 ? (
              <>
                {selectedImg.map((val, key) => (
                  <div className="imgCard" key={key}>
                    <img className="img_sel" src={val} />
                  </div>
                ))}
              </>
            ) : (
              <>
                {inputData.imageTitle ? (
                  <span className="table-text-dark w-max-c db">
                    {inputData.imageTitle.split(",").map((val, key) => (
                      <div
                        className="imgCard"
                        style={{ maxWidth: 120, padding: 5 }}
                      >
                        <img
                          className="img_sel"
                          src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                            inputData.imageFormat.split(",")[key]
                          }`}
                          alt=""
                        />
                      </div>
                    ))}
                  </span>
                ) : (
                  "-"
                )}
              </>
            )}
          </div>
          <div>Upload PDF or Word File</div>
          <div className="form-group mt-0 mb-3 fileUpload-modal">
            <label>
              <input
                name="file"
                onChange={onPDFChange}
                // accept="application/pdf"
                accept=".pdf,.doc,.docx"
                type={"file"}
              />
              {selectedPDF == null && <img src={add} />}
              {selectedPDF && (
                <a href={selectedPDF} download={inputData?.pdfFile}>
                  File Uploaded
                </a>
              )}
            </label>
          </div>

          <div className="sendMailBtn mt-3">
            <button
              onClick={handleSubmit}
              className="btn-dark"
              disabled={isRecording}
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}

var Editor = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
